export class Broadcaster {
  constructor(private $rootScope: ng.IRootScopeService) {}

  send = (name, args) => {
    this.$rootScope.$broadcast(name, args);
  };
}

/*
 * Seviced used to broadcast messages to the application
 */
angular.module('v6CoreModule').service('broadcaster', ($rootScope) => {
  return new Broadcaster($rootScope);
});
